import { useState } from "react";
import { RouterInferenceHelpers } from "../../../../../src/api/trpc/rootRouter";
import type { stripe_utils } from "../../../../../src/utils/stripe_utils";
import { DashboardContainer } from "../../../dashboard/forms/improved_components/base_components/dashboard_container";
import { PricingTable } from "../../../dashboard/forms/improved_components/premium_page/pricing_table";
import { SimpleContactModal } from "./simple-contact-modal";
import { StaticContainer } from "../../components/static-container";
import { PremiumHeader } from "./premium-header";
import { SeshToaster } from "../../../dashboard/forms/improved_components/sesh_toaster";
import { GifFeatureSections } from "./gif-feature-sections";
import { FeatureComparisonTable } from "./feature-comparison-table";
import { CustomBotCard } from "./custom-bot-card";
export function PremiumRoot(props: {
	data: RouterInferenceHelpers["premium"]["getAllProductsPrices"]["output"];
}) {
	const [showContactModal, setShowContactModal] = useState(false);

	return (
		<>
			<SeshToaster />
			<StaticContainer>
				<DashboardContainer size="xl" title={<PremiumHeader />}>
					{/* Main pricing tiers */}
					<PricingTable
						current_pricing={props.data}
						link_type="anchor"
					/>

					{/* Visual feature showcase */}
					<GifFeatureSections />

					{/* Feature comparison table */}
					<FeatureComparisonTable />

					{/* Custom bot card at bottom */}
					<div className="mt-16">
						<CustomBotCard
							onContactClick={() => setShowContactModal(true)}
						/>
					</div>
				</DashboardContainer>
			</StaticContainer>

			{/* Contact modal */}
			{showContactModal && (
				<SimpleContactModal
					onClose={() => setShowContactModal(false)}
				/>
			)}
		</>
	);
}
